import * as React from "react";
import { BlockingModeEnum } from "../../../__generated__/globalTypes";
import styled from "styled-components";
import { Public, VpnLock } from "@mui/icons-material";
import { useTheme } from "@mui/material";
import TypeSelectorItemWithIcon from "./TypeSelectorItemWithIcon";

const Wrapper = styled.div`
    display: flex;
    margin-top: 10px;
    @media (max-width: 620px) {
        flex-direction: column;
    }
`;

interface Props {
    mode: BlockingModeEnum;
    whitelistText: string;
    blacklistText: string;
    onChange: (newMode: BlockingModeEnum) => void;
}

export default function GeoBlockingModeSelector({ mode, onChange, blacklistText, whitelistText }: Props) {
    const theme = useTheme();
    const disabledColor = "rgba(0, 0, 0, 0.12)";

    return (
        <Wrapper>
            <TypeSelectorItemWithIcon
                selected={mode === BlockingModeEnum.whitelist}
                icon={
                    <Public
                        style={{
                            fontSize: "22px",
                            color: mode === BlockingModeEnum.whitelist ? theme.palette.primary.main : disabledColor,
                        }}
                    />
                }
                title="Whitelist"
                description={whitelistText}
                onClick={() => onChange(BlockingModeEnum.whitelist)}
            />
            <TypeSelectorItemWithIcon
                selected={mode === BlockingModeEnum.blacklist}
                icon={
                    <VpnLock
                        style={{
                            fontSize: "22px",
                            color: mode === BlockingModeEnum.blacklist ? theme.palette.primary.main : disabledColor,
                        }}
                    />
                }
                title="Blacklist"
                description={blacklistText}
                onClick={() => onChange(BlockingModeEnum.blacklist)}
            />
        </Wrapper>
    );
}
